import React from 'react';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { formatPhone } from '../../lib/helpers/phone.helpers';
import { ContactRelationship, ContactRelationshipLabels } from '../../lib/types';
import { contactSummaryMessages as messages } from './player-contact.messages';
import { IContactSummary } from './player-contact.types';

interface IContactSummaryRowProps {
  contact: IContactSummary;
  // Row affordances (edit, delete). Absent leaves the row read-only.
  actions?: React.ReactNode;
  disableGutters?: boolean;
}

// One contact as name + relationship over its credentials. Every roster renders
// through this, so a phone is formatted the same wherever a contact appears.
export const ContactSummaryRow: React.FC<IContactSummaryRowProps> = ({ contact, actions, disableGutters }) => (
  <ListItem disableGutters={disableGutters}>
    <ListItemText
      primary={(
        <>
          {contact.name || <IntlMsg {...messages.contactUnnamed} />}
          {!!contact.relationship && (
            <Box component="span" color="text.secondary" fontSize="0.8em" fontWeight={400} ml={0.5}>
              ({ContactRelationshipLabels[contact.relationship as ContactRelationship] || contact.relationship})
            </Box>
          )}
        </>
      )}
      secondary={[contact.email, formatPhone(contact.phone)].filter(Boolean).join(' · ')}
    />
    {actions && <ListItemSecondaryAction>{actions}</ListItemSecondaryAction>}
  </ListItem>
);
